<template>
  <div
    class="design-option-selection secondary-font"
  >
    <label
      class="label"
      :for="`checkbox-${option.groupCode}`"
      :id="`design-option-${option.optionCode}`"
    >
      <div class="row">
        <div class="column">
          <div class="design-option-checkbox">
            <input
              type="checkbox"
              :id="`checkbox-${option.groupCode}`"
              v-model="selection"
              v-if="!option.isDesignNotes"
              class="checkbox"
            />
            <label :for="`checkbox-${option.groupCode}`" class="design-option-label" :class="{designNotes: option.isDesignNotes}">
              {{option.name}}
              <icon-check />
              <div class="design-option-description small" v-if="option.optionData.Description">{{ option.optionData.Description }}</div>
            </label><!-- /.design-option-label -->
          </div><!-- /.design-option-checkbox -->
        </div><!-- /.column -->
        <div class="column">
          <label
            class="label blue price"
            :for="`checkbox-${option.groupCode}`"
            v-if="option.price > 0"
          >+${{option.price}}</label><!-- /.label -->
        </div><!-- /.column -->
      </div><!-- /.row -->
    </label><!-- /.label -->
    <transition name="slide-fade">
      <div v-if="selection && option.optionData.NoteRequired" class="note-required">
        <textarea
          class="design-notes"
          :class="{'error-notes': showError, 'success-notes': showSuccess}"
          :placeholder="option.optionData.NoteInstructions"
          v-model="requiredNotes"
        ></textarea><!-- /.design-notes -->
        <inline-message
          type="error"
          :message="`Please enter at least ${characters} characters`"
          v-show="!showSuccess"
        ></inline-message>
        <inline-message
          type="success"
          message="Note added!"
          v-show="showSuccess"
        ></inline-message>
      </div><!-- /.note-required -->
    </transition>
  </div><!-- /.design-option-selection -->
</template>

<script>
import { mapState, mapActions } from "vuex"
import { notesValid } from "@/helpers/validation"
import { minCharacters } from "@/helpers/values.config.js"
import InlineMessage from "@/components/global/InlineMessage"

export default {
  name: "DesignOptionSelection",
  components: {
    InlineMessage
  },
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      selection: null,
      requiredNotes: null,
      showError: false,
      showSuccess: false,
    }
  },
  created() {
    let selectedOption = this.selectedOptions[this.option.groupCode];
    if (selectedOption) {
      this.requiredNotes = selectedOption.notes;
      this.selection = !!(selectedOption.selected);
    }
  },
  computed: {
    ...mapState(["selectedOptions"]),
    characters() {
      return minCharacters;
    }
  },
  methods: {
    ...mapActions(["pureSelectOptions"]),
    optionObj(value) {
      return {
        // This has to change with other places with this tag: Dingo
        ...this.option,
        name: value,
        notes: this.requiredNotes,
        isDesignOption: true,
        selected: value,
        noteRequired: this.option.noteRequired
      }
    },
    submitNotes(notes) {
      // If not enough characters entered, show error
      // Only save valid notes
      let valid = notesValid(notes);
      let validState = notesValid(
        this.selectedOptions[this.option.groupCode].notes
      );
      let newOption = {};

      if (valid || validState) {
        newOption = {
          ...this.optionObj(this.selection),
        };

        if (validState && !valid) {
          // If you currently have a valid note, and enter an invalid one, clear your note from the state
          newOption.notes = null;
        }

        this.pureSelectOptions({
          var: this.option.groupCode,
          val: newOption,
        });
      }

      this.showError = !notesValid(notes);
      this.showSuccess = notesValid(notes);
    }
  },
  watch: {
    selection: function(value) {
      if (this.option.groupCode == "DIGITALPROOF" && this.selection == false) {
        // If they are unselecting digital proof, warn them of the concequences
        this.$modal.show("digital-proof-modal");
      }
      let opt = this.optionObj(value);
      this.pureSelectOptions({
        var: this.option.groupCode,
        val: opt,
      });
    },
    requiredNotes: function(notes) {
      this.submitNotes(notes);
    }
  },
  mounted() {
    // Set design option values to false when design option step is unlocked
    this.pureSelectOptions({
      // This has to change with other places with this tag: Dingo
      var: this.option.groupCode,
      val: {
        groupName: this.option.name,
        name: this.option.isDefault,
        optional: true,
        groupCode: this.option.groupCode,
        isDesignOption: true,
        isDefault: this.option.isDefault,
        selected: this.option.isDefault,
        noteRequired: this.option.noteRequired,
      }
    });
    if (this.option.isDefault) {
      // Select all default options by default (Currently digital proof and select design notes)
      this.selection = true;
    }
  }
}
</script>
